import CityPageTemplate from "../city-template/CityPageTemplate";
import { memphisConfig } from "./data";

export default function MemphisPage() {
  return <CityPageTemplate config={memphisConfig} />;
}